"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _without2 = _interopRequireDefault(require("lodash/without"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../Button"));
var _Button2 = require("../Button/Button");
var _excluded = ["children"],
  _excluded2 = ["component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ButtonsGroup = /*#__PURE__*/function (_React$PureComponent) {
  function ButtonsGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ButtonsGroup);
    _this = _callSuper(this, ButtonsGroup, [props]);
    _this.state = {
      values: props.values
    };
    _this.buttonsEls = [];
    _this.el = /*#__PURE__*/_react["default"].createRef();
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleButtonsRefs = _this.handleButtonsRefs.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(ButtonsGroup, _React$PureComponent);
  return (0, _createClass2["default"])(ButtonsGroup, [{
    key: "setValue",
    value: function setValue(value) {
      var values = this.state.values;
      var required = this.props.required;
      var nextValues;
      if (values.includes(value)) {
        nextValues = (0, _without2["default"])(values, value);
      } else {
        nextValues = values.concat(value);
      }
      if (!required || !(0, _isEmpty2["default"])(nextValues)) {
        this.setState({
          values: nextValues
        }, this.dispatchChangeEvent);
      }
    }
  }, {
    key: "handleButtonsRefs",
    value: function handleButtonsRefs(component) {
      var element = _reactDom["default"].findDOMNode(component);
      this.buttonsEls.push(element);
    }
  }, {
    key: "handleClick",
    value: function handleClick(_ref) {
      var target = _ref.target;
      var clickedElement = this.buttonsEls.find(function (buttonEl) {
        return buttonEl.contains(target);
      });
      if (!clickedElement) return;
      var value = clickedElement.value;
      this.setValue(value);
    }
  }, {
    key: "dispatchChangeEvent",
    value: function dispatchChangeEvent() {
      var onChange = this.props.onChange;
      var values = this.state.values;
      var event = new CustomEvent('change', {
        bubbles: true,
        detail: {
          value: values
        }
      });
      this.el.current.dispatchEvent(event);
      onChange(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var values = this.state.values;
      return /*#__PURE__*/_react["default"].createElement(StyledButtonsGroup, (0, _extends2["default"])({}, props, {
        ref: this.el
      }), _react["default"].Children.map(children, function (child, index) {
        var value = child.props.value;
        var isChecked = values && values.includes(value);
        return /*#__PURE__*/_react["default"].createElement(StyledButton, {
          "data-index": index,
          component: child,
          checked: isChecked,
          onClick: _this2.handleClick,
          ref: _this2.handleButtonsRefs
        });
      }));
    }
  }]);
}(_react["default"].PureComponent);
ButtonsGroup.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].oneOf([_Button["default"]])
  }).isRequired).isRequired,
  className: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  values: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired)
};
ButtonsGroup.defaultProps = {
  className: '',
  onChange: Function.prototype,
  values: null,
  required: false
};
var StyledButton = (0, _styledComponents["default"])( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var component = props.component,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  return /*#__PURE__*/_react["default"].cloneElement(component, _objectSpread(_objectSpread({}, restProps), {}, {
    ref: ref,
    size: _Button2.Sizes.FLEX
  }));
})).withConfig({
  displayName: "ButtonsGroup__StyledButton",
  componentId: "sc-1n4ptrj-0"
})(["background-color:#e6e6e6;border-radius:84px;height:36px;line-height:34px;min-height:initial;overflow:hidden;padding:0 12px;:hover{border-color:#007aff;color:#007aff;}", ""], function (props) {
  return props.checked && "\n    background-color: #fff;\n    border-color: #fff;\n    color: #17181a;\n    \n    :hover {\n      border-color: #fff;\n      color: #17181a;\n    }\n  ";
});
var StyledButtonsGroup = _styledComponents["default"].div.withConfig({
  displayName: "ButtonsGroup__StyledButtonsGroup",
  componentId: "sc-1n4ptrj-1"
})(["> ", " + ", "{margin-left:10px;}"], StyledButton, StyledButton);
ButtonsGroup.StyledButton = StyledButton;
var _default = exports["default"] = ButtonsGroup;